import { useModalStore } from "@/store/modal/store";
import { XIcon } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import DepositForm from "./deposit-form";
import TransferForm from "./transfer-form";
import WithdrawForm from "./withdraw-form";
import { useDcaStrategyStore } from "@/store/dca-strategy/store";
import { useTranslation } from "react-i18next";


const DepositTransferModal = () => {
  const { t } = useTranslation();
  const { setToDcaWallet } = useDcaStrategyStore();
  const { modal, setModal } = useModalStore();
  const [tab, setTab] = useState<string>('deposit');
  const [step, setStep] = useState<number>(0);

  const onClose = () => {
    setToDcaWallet(null);
    setModal({ deposit: false, transfer: false, withdraw: false });
  }

  useEffect(() => {
    if (modal.deposit || modal.transfer || modal.withdraw) {
      if (modal.transfer) {
        setTab('transfer');
      } else if (modal.withdraw) {
        setTab('withdraw');
      } else {
        setTab('deposit');
      }
    }
  }, [modal.deposit, modal.transfer, modal.withdraw]);

  return (
    <div className="general-modal" style={{ maxWidth: '528px' }}>
      <div className="general-modal__header">
        {t(`common.${tab}_funds`)}
        <div className="general-modal__close" onClick={onClose}>
          <XIcon />
        </div>
      </div>
      <div className="deposit__tabs">
        <div
          className={`deposit__tabs-item ${tab === 'deposit' ? 'active' : ''}`}
          onClick={() => setTab('deposit')}
        >
          {t('common.deposit')}
        </div>
        <div
          className={`deposit__tabs-item ${tab === 'transfer' ? 'active' : ''}`}
          onClick={() => setTab('transfer')}
        >
          {t('common.transfer')}
        </div>
        <div
          className={`deposit__tabs-item ${tab === 'withdraw' ? 'active' : ''}`}
          onClick={() => setTab('withdraw')}
        >
          {t('common.withdraw')}
        </div>
      </div>
      <div style={{ display: tab === 'deposit' ? 'block' : 'none' }}>
        <DepositForm step={step} setStep={setStep} onClose={onClose} />
      </div>
      <div style={{ display: tab === 'transfer' ? 'block' : 'none' }}>
        <TransferForm onClose={onClose} />
      </div>
      <div style={{ display: tab === 'withdraw' ? 'block' : 'none' }}>
        <WithdrawForm onClose={onClose} />
      </div>
    </div>
  )
}

export default DepositTransferModal
